// ===== UI SELECTORS =====
// src/features/auth/state/ui-state/uiSelectors.ts

import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/app/store';

export const selectHasErrors = createSelector(
  [(state: RootState) => state.ui.errors],
  (errors) => Object.keys(errors).length > 0
);

export const selectActiveNotifications = createSelector(
  [(state: RootState) => state.ui.notifications],
  (notifications) => {
    const now = new Date().getTime();
    return notifications.filter(n => {
      const timestamp = new Date(n.timestamp).getTime();
      const duration = n.duration || 5000;
      return now - timestamp < duration;
    });
  }
);

export const selectIsAnyLoading = createSelector(
  [(state: RootState) => state.ui.loading],
  (loading) => Object.values(loading).some(isLoading => isLoading)
);

export const selectActiveModalsCount = createSelector(
  [(state: RootState) => state.ui.modals],
  (modals) => modals.length
);
